<template>
  <!-- Navbar -->
  <nav :class="navbarClass">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button">
          <i class="fas fa-bars"></i>
        </a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <li class="nav-item dropdown user-menu" :class="{ show: dropdownOpen }">
        <!--
          data-bs-toggle は使わない。AdminLTE 3.1 が前提とする Bootstrap 4 の
          jQuery プラグイン ($.fn.dropdown) が Bootstrap 5 には無く、
          属性任せでは開閉しないため Vue 側で制御する。
        -->
        <a
          href="#"
          class="nav-link dropdown-toggle"
          :aria-expanded="dropdownOpen ? 'true' : 'false'"
          @click.prevent.stop="dropdownOpen = !dropdownOpen"
        >
          <i class="fas fa-user-circle mr-1"></i>
          <span class="d-none d-md-inline">{{ userName }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right user-dropdown" :class="{ show: dropdownOpen }">
          <!-- User info -->
          <div :class="navbarDropDown">
            <p class="user-dropdown-name">{{ userName }}</p>
            <p v-if="shop_name" class="user-dropdown-shop">
              <i class="fas fa-store mr-1"></i>{{ shop_name }}
            </p>
          </div>

          <!-- Shop switch -->
          <template v-if="shops && shops.length > 0">
            <h6 class="dropdown-header">店舗を切替</h6>
            <a
              v-for="s in shops"
              :key="s.id"
              href="#"
              :class="['dropdown-item shop-item', { active: s.id === currentShopId }]"
              @click.prevent="switchShop(s)"
            >
              <i class="fas fa-store mr-2"></i>{{ s.shop_name }}
            </a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item" @click.prevent="goToCompanyTop">
              <i class="fas fa-building mr-2"></i>会社TOPに戻る
            </a>
            <div class="dropdown-divider"></div>
          </template>

          <!-- Back to Admin -->
          <a v-if="hasAdminBackup" href="#" class="dropdown-item text-primary" @click.prevent="backToAdmin">
            <i class="fas fa-shield-alt mr-2"></i>管理者に戻る
          </a>
          <div v-if="hasAdminBackup" class="dropdown-divider"></div>

          <!-- Logout -->
          <a href="#" class="dropdown-item text-danger" @click.prevent="logout">
            <i class="fas fa-sign-out-alt mr-2"></i>ログアウト
          </a>
        </div>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'NavBar',
  data() {
    return {
      dropdownOpen: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown);
  },
  unmounted() {
    document.removeEventListener('click', this.closeDropdown);
  },
  computed: {
    ...mapGetters(['userName', 'userPermission', 'shop', 'shop_name', 'shops']),
    currentShopId() {
      return this.shop ? parseInt(this.shop) : null;
    },
    hasAdminBackup() {
      return !!localStorage.getItem('adminBackup');
    },
    navbarClass() {
      return {
        'main-header navbar navbar-expand navbar-primary navbar-dark': this.userPermission === 1,
        'main-header navbar navbar-expand navbar-success navbar-dark': this.userPermission === 2,
        'main-header navbar navbar-expand navbar-info navbar-dark': this.userPermission === 3,
      };
    },
    navbarDropDown() {
      return {
        'user-dropdown-header bg-primary': this.userPermission === 1,
        'user-dropdown-header bg-success': this.userPermission === 2,
        'user-dropdown-header bg-info': this.userPermission === 3,
      };
    },
  },
  methods: {
    closeDropdown() {
      this.dropdownOpen = false;
    },
    backToAdmin() {
      this.closeDropdown();
      const backup = JSON.parse(localStorage.getItem('adminBackup'));
      if (backup) {
        const data = {
          data: {
            access: backup.permission,
            token: backup.token,
            userName: backup.userName,
          }
        };
        localStorage.removeItem('adminBackup');
        this.$store.dispatch('setAuth', data).then(() => {
          this.$router.push({ name: 'TopPage' });
        });
      }
    },
    logout() {
      this.closeDropdown();
      this.$store.dispatch('logout').then(() => {
        this.$router.push({ name: 'Login' });
      });
    },
    switchShop(shop) {
      this.closeDropdown();
      const data = {
        data: {
          access: 3,
          company_id: this.$store.getters.company,
          shop_id: shop.id,
          shop_name: shop.shop_name,
          token: this.$store.getters.token,
          userName: this.$store.getters.userName,
          shops: this.shops,
        }
      };
      this.$store.dispatch('setAuth', data).then(() => {
        this.$router.push({ name: 'StoreTopPage' });
      });
    },
    goToCompanyTop() {
      this.closeDropdown();
      const data = {
        data: {
          access: 2,
          company_id: this.$store.getters.company,
          token: this.$store.getters.token,
          userName: this.$store.getters.userName,
          shops: this.shops,
        }
      };
      this.$store.dispatch('setAuth', data).then(() => {
        this.$router.push({ name: 'CompanyTopPage' });
      });
    },
  }
}
</script>

<style scoped>
  .navbar .nav-link span {
    color: #FFF !important;
  }

  .navbar .nav-link i {
    color: #FFF !important;
  }

  /* User dropdown */
  .user-dropdown {
    min-width: 240px;
    border-radius: 10px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.12);
    border: 1px solid #e2e8f0;
    padding: 0;
    overflow: hidden;
  }

  .user-dropdown-header {
    padding: 16px;
    color: #fff;
  }

  .user-dropdown-name {
    font-size: 15px !important;
    font-weight: 700;
    margin: 0;
    color: #fff !important;
  }

  .user-dropdown-shop {
    font-size: 13px !important;
    margin: 4px 0 0;
    opacity: 0.85;
    color: #fff !important;
  }

  .user-dropdown .dropdown-header {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #718096;
    padding: 10px 16px 4px;
  }

  .user-dropdown .dropdown-item {
    font-size: 14px;
    padding: 8px 16px;
    color: #2d3748;
    transition: background-color 0.15s ease;
  }

  .user-dropdown .dropdown-item:hover {
    background-color: #f0faf4;
    color: #049C4C;
  }

  .user-dropdown .dropdown-item.active {
    background-color: #049C4C;
    color: #fff;
    font-weight: 600;
  }

  .user-dropdown .dropdown-item.text-danger:hover {
    background-color: #fff5f5;
    color: #e53e3e;
  }

  .user-dropdown .dropdown-divider {
    margin: 4px 0;
  }

  .shop-item {
    font-size: 13px;
  }
</style>
